const splashScreen = document.querySelector( '.splash-screen' );

window.onload = function() {
	if ( splashScreen ) {
		document.body.classList.add( 'page-with-splash-screen' );
	} else {
		document.body.classList.add( 'reset-site-header' );
	}
};

if ( splashScreen ) {
	window.onscroll = () => {
		if ( window.scrollY > 200 ) {
			document.body.classList.remove( 'page-with-splash-screen' );
			document.body.classList.add( 'reset-site-header' );
		} else {
			document.body.classList.add( 'page-with-splash-screen' );
			document.body.classList.remove( 'reset-site-header' );
		}
	};
}
